'use client';

import { apiFetch } from './api';

export interface GalleryPhoto {
  id: string;
  image: string;
  alt: string;
  title: string;
  category: string;
  date: string;
}

interface PublicPhotoRow {
  id: string;
  title: string | null;
  description: string | null;
  category: string;
  createdAt: string;
  url: string;
}

export const galleryService = {
  // Get all public (portfolio) photos — gallery name is the category
  async getPublicPhotos(): Promise<GalleryPhoto[]> {
    try {
      const { photos } = await apiFetch<{ photos: PublicPhotoRow[] }>('/api/gallery');
      return photos.map((photo) => ({
        id: photo.id,
        image: photo.url,
        alt: photo.description || photo.title || 'Photo',
        title: photo.title || '',
        category: photo.category,
        date: new Date(photo.createdAt).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
      }));
    } catch (e) {
      console.error('Error fetching public photos:', e);
      return [];
    }
  },
};
